<table
    [id]="id()"
    [attr.data-testid]="id()"
    [attr.data-styletarget]="id()"
    [attr.data-uitype]="'table'"
    class="w-full"
>
    <tr
        [id]="id() + '-header-row'"
        [attr.data-testid]="id() + '-header-row'"
        [attr.data-styletarget]="id() + '-header-row'"
        [attr.data-uitype]="'table-row-header'"
        class="grid grid-cols-4 text border-dat-grey-200 border-b border-solid"
    >
        @for (colKey of colKeys(); track $index) {
        <th
            [id]="currentHeaderRow()?.[colKey]?.id + '-header-col'"
            [attr.data-testid]="
                currentHeaderRow()?.[colKey]?.id + '-header-col'
            "
            [attr.data-styletarget]="
                currentHeaderRow()?.[colKey]?.id + '-header-col'
            "
            [attr.data-uitype]="'table-col-header'"
            (click)="headerClick(colKey, currentHeaderRow()?.[colKey])"
            class="flex items-center justify-end first:justify-start gap-x-1 px-4 font-caption text-dat-grey-500 cursor-pointer hover:bg-dat-grey-050 active:bg-dat-grey-100 h-10"
        >
            <span
                [datiqTemplateMd]="currentHeaderRow()?.[colKey]?.label"
            ></span>
            @if (currentHeaderRow()?.[colKey]?.sort !== 'none') {
            <span class="material-symbols-outlined text-[16px]">
                {{ currentHeaderRow()?.[colKey]?.sort }}
            </span>
            }
        </th>
        }
    </tr>
    @if (isLoaded()) { @for (row of sortedRows(); track i; let i = $index) {
    <tr
        [id]="id() + '-row-' + i"
        [attr.data-testid]="id() + '-row-' + i"
        [attr.data-styletarget]="id() + '-row-' + i"
        [attr.data-uitype]="'table-row'"
        class="grid grid-cols-4 text-center font-body-2 border-b-dat-grey-100 border-solid border-b h-[41px] last:border-b-0 last:h-10"
    >
        @for(colKey of colKeys(); track $index) {
        <td
            [id]="row?.[colKey]?.id + '-col'"
            [attr.data-testid]="row?.[colKey]?.id + '-col'"
            [attr.data-styletarget]="row?.[colKey]?.id + '-col'"
            [attr.data-uitype]="'table-col'"
            [datiqTemplateMd]="row?.[colKey].label"
            class="flex items-center justify-end first:justify-start px-4"
        ></td>
        }
    </tr>
    } } @else { @for (row of emptyRows(); track i; let i = $index) {
    <tr
        [id]="id() + '-row-' + i"
        [attr.data-testid]="id() + '-row-' + i"
        [attr.data-styletarget]="id() + '-row-' + i"
        [attr.data-uitype]="'table-row'"
        [style.animation-delay]="i * 0.1 + 's'"
        [style.animation-duration]="0.5 + 's'"
        class="grid grid-cols-4 text-center font-body-2 animate-pulse my-2 bg-dat-grey-100 h-10"
    >
        @for (colKey of colKeys(); track $index) {
        <td
            [id]="row?.[colKey]?.id + '-col'"
            [attr.data-testid]="row?.[colKey]?.id + '-col'"
            [attr.data-styletarget]="row?.[colKey]?.id + '-col'"
            [attr.uitype]="'table-col'"
            [datiqTemplateMd]="row?.[colKey].label"
        ></td>
        }
    </tr>
    } }
</table>
